module.exports = __webpack_public_path__ + "img/1alB-b-bex.55e64cb9.jpg";